<template>
  <div class="page">
    <h1>这是分类页面</h1> <!-- 必须有可见内容 -->
    <p></p>
  </div>
</template>
